import {PlaceValueObject} from "../../../vo/content/place/PlaceValueObject";
import {DataTransferObjectValidation} from "../../../../type/Types";

export namespace PlaceDataTransferObject {
    export type Post = {
        isActive: boolean
        exposedAt: string
        placeMissionType: number
        placeNumber: string | null
        placeName: string | null
        placeImageUrl: string | null
        placeTelephoneNumber: string | null
        answer: string | null
        placeUrl: string | null
        attractionNameString: string | null
        keywordString: string | null
        amount: bigint | null
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = PlaceValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            isActive(o: string): boolean | Error {
                return DataTransferObjectValidation.transformBoolean(o, 'isActive')
            },
            exposedAt(o: string): string | Error {
                return DataTransferObjectValidation.validateDate(o, 'exposedAt')
            },
            placeMissionType(o: string): number | Error {
                return DataTransferObjectValidation.transformNumber(o, 'placeMissionType')
            },
            placeNumber(o: string): string | Error {
                return DataTransferObjectValidation.validateBigInt(o, 'placeNumber')
            },
            placeName(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'placeName')
            },
            placeImageUrl(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'placeImageUrl')
            },
            placeTelephoneNumber(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'placeTelephoneNumber')
            },
            answer(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'answer')
            },
            placeUrl(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'placeUrl')
            },
            attractionNameString(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'attractionNameString')
            },
            keywordString(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'keywordString')
            },
            amount(o: string): bigint | null | Error {
                return DataTransferObjectValidation.transformBigIntOrNullIfEmpty(o, 'amount')
            }
        }
    }

    export type Put = {
        isActive: boolean
        exposedAt: string
        placeMissionType: number
        placeNumber: string | null
        placeName: string | null
        placeImageUrl: string | null
        placeTelephoneNumber: string | null
        answer: string | null
        placeUrl: string | null
        attractionNameString: string | null
        keywordString: string | null
        amount: bigint | null
    }

    export namespace Put {
        export const description: Record<keyof Put, string> = PlaceValueObject.description

        export const validation: DataTransferObjectValidation<Put> = {
            isActive(o: string): boolean | Error {
                return DataTransferObjectValidation.transformBoolean(o, 'isActive')
            },
            exposedAt(o: string): string | Error {
                return DataTransferObjectValidation.validateDate(o, 'exposedAt')
            },
            placeMissionType(o: string): number | Error {
                return DataTransferObjectValidation.transformNumber(o, 'placeMissionType')
            },
            placeNumber(o: string): string | Error {
                return DataTransferObjectValidation.validateBigInt(o, 'placeNumber')
            },
            placeName(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'placeName')
            },
            placeImageUrl(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'placeImageUrl')
            },
            placeTelephoneNumber(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'placeTelephoneNumber')
            },
            answer(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'answer')
            },
            placeUrl(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'placeUrl')
            },
            attractionNameString(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'attractionNameString')
            },
            keywordString(o: string): string | null {
                return DataTransferObjectValidation.validateStringOrNullIfEmpty(o, 'keywordString')
            },
            amount(o: string): bigint | null | Error {
                return DataTransferObjectValidation.transformBigIntOrNullIfEmpty(o, 'amount')
            }
        }
    }
}